import { MODAL_SHOW,MODAL_HIDE, MODAL_NOTIFICATION_SET, MODAL_NOTIFICATION_CLEAR } from "../store/config";

const modalInit={
	show:false,
	data: {},
	active: false,
	timestamp: null
};

export const modal = (state=modalInit,action) => {
	switch (action.type){
		case MODAL_SHOW:
			return {
				...state,
				show:action.show,
				timestamp:action.timestamp
			};
		case MODAL_HIDE:
			return {
				...state,
				show:action.show,
				data:action.data,
				active:action.active,
				timestamp:action.timestamp
			};
		case MODAL_NOTIFICATION_SET:
			return {
				...state,
				data:action.data,
				active:action.active,
				timestamp:action.timestamp
			};
		case MODAL_NOTIFICATION_CLEAR:
			return {
				...state,
				data:action.data,
				active:action.active,
				timestamp:action.timestamp
			};
		default:
			return {
				...state
			};
	}
};

export default modal;


// WEBPACK FOOTER //
// ./src/reducers/modal.js